<template>
    <div>
        <div v-if="pro">
            <img :src="pro.banner" alt="" style="width: 100%;">

            <div style="padding:1rem .5rem;box-sizing: border-box;">
                <div class="flex">
                    <img :src="pro.logo" alt="" style="width: 1.2rem;height: auto;">
                    <span style="margin-left:.4rem;font-size:.8rem;">{{pro.productName}}</span>
                </div>
                <div style="margin-top:.3rem;color:#7C8CAC;font-size:.5rem;line-height: .8rem;">
                    {{pro.proDescribe}}
                </div>
            </div>
        </div>
        
        <div class="part-tit">软件亮点</div>
        <div style="text-align: center;">            
             <img :src="img" alt="" v-for="(img,m) of softwareHighlight" :key="'img'+m" style="width: 95%;margin-bottom: 2rem;">
        </div>
        
    </div>
</template>

<script>
export default {
    data(){
        return{
            id:0,
            pro:null,
            softwareHighlight:[],            
        }
    },
    created(){
        this.id = this.$route.query.id        
        // console.log(this.pro)
        this._get(this.API.productList+'?pageNo=1&pageSize=100').then(res=>{
            // console.log('产品列表=====',res)
            if(res.code==200){
                this.productArr = res.data.records
                this.pro = this.productArr.find(item=>item.id==this.id)
                this.softwareHighlight = this.pro.softwareHighlight.split(',')               
            }

        })
    },
    methods:{

    }
}
</script>
<style lang="less" scoped>
.ban-box{
    height: calc(100vw / (1920 / 440) );
    background-size: 100%;
}
.part-tit{
    width: 100%;
    font-size: .7rem;
    text-align: center;
    padding: 1.5rem 0;
}
</style>